// extracted by mini-css-extract-plugin
module.exports = {"content":"EduArticleBody_content__yfJcy","slide-in-out":"EduArticleBody_slide-in-out__1F_sj","fade-in-out":"EduArticleBody_fade-in-out__8dT63"};